// export const loaderImageVex = ({ src, width }: { src: any, width: any }) => `https://uat-goyolo.vexere.net/_next/image?url=${src}&w=${width}&q=75`;
export const loaderImageVex = ({ src, width }: { src: any, width: any }) => src;
